import { createSlice, current } from '@reduxjs/toolkit'
import { getGamificationData } from 'redux-store/thunk/gamification.thunk'
import { FREE_SPINS_STATE } from 'utils/constants/index'

const defaultGamificationState = {
  gamificationData: {
    campaigns: [],
  },
  gamificationArgs: {},
  loading: false,
  error: null
}

// #region Gamification Data and Args Example
// for example:
// gamificationArgs: {
//   freeSpin: {
//     isFreeSpin: true,
//     featureId: 1,
//     campaignId: 1
//   }
// }
// gamificationData: {
//   campaigns: [{
//   campaignId: 0,
//   campaignReferenceId: 'abc123',
//   name: 'Free Spin Campaign',
//   description: 'This is a free spin campaign',
//   startDate: '2026-01-01',
//   endDate: '2026-01-01',
//   freeSpinDetails: [{
//     featureName: 'Free Spin',
//     featureReferenceId: 'abc123',
//     featureId: 1,
//     spinsLeft: 10,
//     maxSpins: 10,
//     state: 'active',
//     betAmount: 10,
//     expirationDate: '2026-01-01'
//   }]
// }]
// }
//#endregion

const gamificationSlice = createSlice({
  name: 'gamificationSlice',
  initialState: defaultGamificationState,
  reducers: {
    setGamificationArgs: (state, action) => ({
      ...state,
      gamificationArgs: {
        ...state.gamificationArgs,
        ...action.payload
      }
    }),
    setGamificationData: (state, action) => ({
      ...state,
      gamificationData: {
        ...state.gamificationData,
        ...action.payload
      }
    }),
    updateGamificationData: (state, action) => {
      if (action.payload?.data?.update?.type === 'freeSpin') {
        console.log('updateGamificationData before', current(state.gamificationData))
        const { campaignId, featureId, gameId, freeSpinDetail } = action.payload.data?.update || {}
        const nextState = {
          ...state,
          gamificationData: {
            ...state.gamificationData,
            campaigns: state.gamificationData.campaigns.map((campaign) => {
              if (campaign.campaignId !== campaignId) return campaign

              const updatedFreeSpinDetails = (campaign.freeSpinDetails || [])
              .map((fs) => {
                if (+fs.freeSpinDetailId === +freeSpinDetail.id) {
                  if (freeSpinDetail.state !== FREE_SPINS_STATE.ACTIVE) {
                      return null // consumed or other non-active: remove below
                    }
                    return { ...fs, ...freeSpinDetail }
                  }
                  return fs
                })
                .filter(Boolean)

              return {
                ...campaign,
                freeSpinDetails: updatedFreeSpinDetails
              }
            })
          }
        }
        console.log('updateGamificationData after', JSON.parse(JSON.stringify(nextState.gamificationData)))
        return nextState
      } else {
        return state
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getGamificationData.fulfilled, (state, action) => {
      return {
        ...state,
        gamificationData: action.payload
      }
    })
  }
})

export const {
  setGamificationArgs,
  setGamificationData,
  updateGamificationData
} = gamificationSlice.actions

export default gamificationSlice.reducer
